import type { UpdateUserProfileBodyPreferencesTheme } from './updateUserProfileBodyPreferencesTheme';

export type UpdateUserProfileBodyPreferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: UpdateUserProfileBodyPreferencesTheme;
};
